import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=656fb4e0"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=656fb4e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports